import { REGEX } from 'www/utils'
import i18next from 'i18next'
import { MAX_FIO_LENGTH, MAX_FIO_LENGTH_YDOC } from 'www/vue_components/common/AppointmentPage/constants'

/**
 * @callback Rule
 * @param { any } val -
 *
 * @returns { true | string } -
 */
/** @typedef { Rule } OnlyRuRule */
/** @typedef { Rule } OnlyLettersRule */
/** @typedef { Rule } MaxLengthRule */
/** @typedef { Rule } RequiredRule */

/**
 * @param { string } requiredDescription -
 *
 * @returns { { onlyRu: OnlyRuRule, maxLength: MaxLengthRule, required: RequiredRule } } -
 */

const options = { ns: i18next.language }
const getFioValidationRules = requiredDescription => {
  const maxFioLength = window.IS_YDOC
    ? MAX_FIO_LENGTH_YDOC
    : MAX_FIO_LENGTH

  /** @type { OnlyRuRule } */
  const onlyRu = val => REGEX.fio.test(val) || i18next.t('Используйте только кириллицу', options)
  /** @type { OnlyLettersRule } */
  const onlyLetters = val => REGEX.ydocFio.test(val) || i18next.t('Используйте только буквы, дефис, пробел и апостроф', options)
  /** @type { MaxLengthRule } */
  const maxLength = val => val.length <= maxFioLength || i18next.t('Должно быть не больше {count} символов', { ...options, count: maxFioLength })
  /** @type { RequiredRule } */
  const required = val => !!val || i18next.t(requiredDescription, options)

  return {
    onlyRu,
    onlyLetters,
    maxLength,
    required,
  }
}

export default getFioValidationRules
